import repository from '@/repositories/Repository'

const resource = '/api/forecasts'

export default {
  get(company) {
    return repository.frog
      .get(`${resource}/result/${company}`)
      .then(r => r.data)
  },
  getDownloadUrl(company, id, notExported) {
    return repository
      .frog(`${resource}/file/${company}/${id}?notExported=${notExported}`)
      .then(r => r.data)
  },
  edit(company, postData) {
    return repository.frog
      .post(`${resource}/edit/${company}`, postData)
      .then(r => r.data)
  },
}
